import {
  IDoctorReviewRequest,
  IDoctorReviewResponse,
  IHelpMeChooseDoctorRequest,
  IHelpMeChooseDoctorResponse,
  IPaymentPayload,
  IPaymentResponse,
  IReserveAppointmentPatientRequest,
  IReserveAppointmentResponse,
  ISpecialitiesListResponse,
} from "@/models/ApiRequestResponse/patient";

import { GBSCError } from "@/models/GBSCError";
import { IFindDoctorList } from "@/models/ApiRequestResponse/patient";
import { IKeyPairsValues } from "@/models/doctor";

import { get, post } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "@/utils/apis/APIEndpointConfig";
import { getLocation, LIMIT } from "@/utils";

export const getDoctorsSpecialitiesListApi = async (): Promise<
  ISpecialitiesListResponse | GBSCError
> => {
  try {
    const response = await get<ISpecialitiesListResponse>(
      APIEndpoint.patient.specialitiesList
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getFindDoctorListApi = async (
  params: string,
  signal?: AbortSignal
): Promise<IFindDoctorList | GBSCError> => {
  try {
    const response = await get<IFindDoctorList>(
      `${APIEndpoint.patient.findDoctor}${params}`,
      signal
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getSearchDoctorApi = async (
  params: IKeyPairsValues
): Promise<IFindDoctorList | GBSCError> => {
  try {
    const locationVal = getLocation();
    let url = `${APIEndpoint.patient.doctor}?limit=${LIMIT}&latitude=${locationVal?.latitude}&longitude=${locationVal?.longitude}`;
    url += params?.offset ? `&offset=${params.offset}` : "";
    url += params?.search ? `&search=${params.search}` : "";
    const response = await get<IFindDoctorList>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const reserveAppointmentFromPatient = async (
  requestBody: IReserveAppointmentPatientRequest
): Promise<IReserveAppointmentResponse | GBSCError> => {
  try {
    const response = await post<IReserveAppointmentResponse>(
      APIEndpoint.patient.bookingAppointment,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const postReviewToDoctorApi = async (
  requestBody: IDoctorReviewRequest
): Promise<IDoctorReviewResponse | GBSCError> => {
  try {
    const response = await post<IDoctorReviewResponse>(
      APIEndpoint.patient.postReview,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const postHelpMeChooseDoctorApi = async (
  requestBody: IHelpMeChooseDoctorRequest
): Promise<IHelpMeChooseDoctorResponse | GBSCError> => {
  try {
    const response = await post<IHelpMeChooseDoctorResponse>(
      APIEndpoint.patient.helpMeChooseDoctor,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const initiatePaymentApi = async (
  requestBody: IPaymentPayload
): Promise<IPaymentResponse | GBSCError> => {
  try {
    const response = await post<IPaymentResponse>(
      APIEndpoint.patient.initiatePayment,
      requestBody
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
